module.exports = __webpack_public_path__ + "media/images/icon/icons8-Notification-de9fc1829798f93311824e218b6317e3.png";